import { Button, DatePicker, Form, Input, Modal } from 'antd';
import React, { useEffect } from 'react';
import { ModalCloseBox } from '../../EmployeesStyle';
import { ModalCloseIcon } from '../../../../theme/SvgIcons';
import styled from '@emotion/styled';
import { FieldBox, FlexWrapper } from '../../../../theme/common_style';
import PropTypes from 'prop-types';
import { CustomCheckbox, VerticalCheckboxGroup } from '../../../hms/HmsFilter';
import dayjs from 'dayjs';
import { empStatus } from '../../../../utils/constant';
import { useResponsiveModalWidth } from '../../../../hooks/useResponsiveModalWidth';

const DoneTaskArr = [
  { label: 'Project KT', value: 'Project KT' },
  { label: 'Handover Office Items', value: 'Handover Office Items' },
  { label: 'Relieving Documents', value: 'Relieving Documents' },
  { label: 'Salary Slip', value: 'Salary Slip' }
];

const RelievingModal = ({ open, onClose, handleSubmit, loading, details }) => {
  const [form] = Form.useForm();
  const width = useResponsiveModalWidth(600);

  const handleFormData = async (values) => {
    const payload = {
      ...values,
      relieving_date: dayjs(values.relieving_date).format('YYYY-MM-DD')
    };
    handleSubmit(payload);
  };

  useEffect(() => {
    if (details?.relieving_date) {
      form.setFieldsValue({
        relieving_date: dayjs(details?.relieving_date),
        note: details?.note,
        relieving_checklist: details?.relieving_checklist
      });
    }
  }, [open, details]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      prefixCls="create-employees"
      width={width}
      centered
      closeIcon={false}
      footer={null}>
      <ModalCloseBox onClick={onClose}>
        <ModalCloseIcon />
      </ModalCloseBox>
      <ContentBox>
        <h4>Relieving</h4>
        <Form form={form} onFinish={handleFormData}>
          <FieldBox>
            <label>
              Relieving Date <span>*</span>
            </label>
            <Form.Item
              name="relieving_date"
              rules={[
                {
                  required: true,
                  type: 'date',
                  message: 'Relieving date is required'
                }
              ]}>
              <DatePicker
                disabled={details?.status === empStatus?.DELETED}
                prefixCls="form-datepicker"
                format="YYYY-MM-DD"
                placeholder="YYYY-MM-DD"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </FieldBox>
          <FieldBox>
            <FlexWrapper justify="space-between">
              <label>Note</label>
            </FlexWrapper>
            <Form.Item name="note" type="text" rules={[{ required: false }]}>
              <Input.TextArea
                readOnly={details?.status === empStatus?.DELETED}
                style={{ resize: 'none' }}
                maxLength={1000}
                placeholder="Write a note here"
                rows={5}
              />
            </Form.Item>
          </FieldBox>
          <FieldBox>
            <label style={{ fontWeight: 600 }}>Done Points</label>
            <Form.Item name="relieving_checklist">
              <VerticalCheckboxGroup>
                {DoneTaskArr?.map((el) => (
                  <CustomCheckbox
                    disabled={details?.status === empStatus?.DELETED}
                    key={el?.value}
                    value={el?.value}>
                    {el?.label}
                  </CustomCheckbox>
                ))}
              </VerticalCheckboxGroup>
            </Form.Item>
          </FieldBox>
          <FlexWrapper justify="end" style={{ marginTop: 20 }}>
            {details?.status !== empStatus?.DELETED && (
              <Button
                onClick={() => form.submit()}
                loading={loading}
                style={{ width: 140 }}
                prefixCls="antCustomBtn">
                Relieved Now
              </Button>
            )}
          </FlexWrapper>
        </Form>
      </ContentBox>
    </Modal>
  );
};

export default RelievingModal;

RelievingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  details: PropTypes.object
};

const ContentBox = styled.div`
  width: 100%;
  padding: 24px;

  h4 {
    font-family: 'Plus Jakarta Sans';
    font-weight: 700;
    font-size: 24px;
    color: #0e0e0e;
    margin: 0;
    text-align: center;
  }

  .custom-checkbox-label {
    color: #000 !important;
  }
`;
